// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: w8Gkq37ZXmVbqHV15DJUBW
// Component: 7yzX8XASK2
import * as React from "react";
import {
  PlasmicLink as PlasmicLink__,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  hasVariant,
  renderPlasmicSlot,
  useDollarState
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";
import "@plasmicapp/react-web/lib/plasmic.css";
import projectcss from "./plasmic_basil_site_2_0.module.css"; // plasmic-import: w8Gkq37ZXmVbqHV15DJUBW/projectcss
import sty from "./PlasmicTweetIndividual.module.css"; // plasmic-import: 7yzX8XASK2/css

createPlasmicElementProxy;

export const PlasmicTweetIndividual__VariantProps = new Array(
  "fullWidthAcross"
);

export const PlasmicTweetIndividual__ArgProps = new Array(
  "tweetLink",
  "accountName",
  "tweetText"
);

const $$ = {};

function PlasmicTweetIndividual__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  const stateSpecs = React.useMemo(
    () => [
      {
        path: "fullWidthAcross",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $ctx }) => $props.fullWidthAcross
      }
    ],

    [$props, $ctx, $refs]
  );
  const $state = useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $refs
  });
  return (
    <button
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        projectcss.all,
        projectcss.button,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        projectcss.plasmic_tokens,
        sty.root,
        {
          [sty.rootfullWidthAcross]: hasVariant(
            $state,
            "fullWidthAcross",
            "fullWidthAcross"
          )
        }
      )}
    >
      <PlasmicLink__
        data-plasmic-name={"link"}
        data-plasmic-override={overrides.link}
        className={classNames(projectcss.all, projectcss.a, sty.link, {
          [sty.linkfullWidthAcross]: hasVariant(
            $state,
            "fullWidthAcross",
            "fullWidthAcross"
          )
        })}
        platform={"react"}
      >
        <div className={classNames(projectcss.all, sty.freeBox___9Fh8S)}>
          <div className={classNames(projectcss.all, sty.freeBox__pv8Qd)}>
            <div className={classNames(projectcss.all, sty.freeBox__nOzSr)}>
              <div
                data-plasmic-name={"accountName"}
                data-plasmic-override={overrides.accountName}
                className={classNames(projectcss.all, sty.accountName)}
              >
                {renderPlasmicSlot({
                  defaultContents: "account name",
                  value: args.accountName,
                  className: classNames(sty.slotTargetAccountName)
                })}
              </div>
            </div>
            <div
              data-plasmic-name={"tweetText"}
              data-plasmic-override={overrides.tweetText}
              className={classNames(projectcss.all, sty.tweetText, {
                [sty.tweetTextfullWidthAcross]: hasVariant(
                  $state,
                  "fullWidthAcross",
                  "fullWidthAcross"
                )
              })}
            >
              {renderPlasmicSlot({
                defaultContents: "tweet here",
                value: args.tweetText,
                className: classNames(sty.slotTargetTweetText)
              })}
            </div>
          </div>
          <div className={classNames(projectcss.all, sty.freeBox__oxTc6)}>
            <button
              data-plasmic-name={"greenButton3"}
              data-plasmic-override={overrides.greenButton3}
              className={classNames(
                projectcss.all,
                projectcss.button,
                sty.greenButton3
              )}
              ref={ref => {
                $refs["greenButton3"] = ref;
              }}
            >
              <div
                data-plasmic-name={"text"}
                data-plasmic-override={overrides.text}
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.text
                )}
              >
                {"Read article"}
              </div>
            </button>
          </div>
        </div>
      </PlasmicLink__>
    </button>
  );
}

const PlasmicDescendants = {
  root: ["root", "link", "accountName", "tweetText", "greenButton3", "text"],
  link: ["link", "accountName", "tweetText", "greenButton3", "text"],
  accountName: ["accountName"],
  tweetText: ["tweetText"],
  greenButton3: ["greenButton3", "text"],
  text: ["text"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicTweetIndividual__ArgProps,
          internalVariantPropNames: PlasmicTweetIndividual__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicTweetIndividual__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicTweetIndividual";
  } else {
    func.displayName = `PlasmicTweetIndividual.${nodeName}`;
  }
  return func;
}

export const PlasmicTweetIndividual = Object.assign(
  // Top-level PlasmicTweetIndividual renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    link: makeNodeComponent("link"),
    accountName: makeNodeComponent("accountName"),
    tweetText: makeNodeComponent("tweetText"),
    greenButton3: makeNodeComponent("greenButton3"),
    text: makeNodeComponent("text"),
    // Metadata about props expected for PlasmicTweetIndividual
    internalVariantProps: PlasmicTweetIndividual__VariantProps,
    internalArgProps: PlasmicTweetIndividual__ArgProps
  }
);

export default PlasmicTweetIndividual;
/* prettier-ignore-end */
